/**
 * Cart Quantity-Variant Stepper + Unified Bulk Savings Display
 *
 * 1) For products where "Quantity" is a variant option, the Shopify cart qty
 *    is locked at 1 and +/- buttons step through variant tiers.
 *
 * 2) For ALL products (old + v2 templates), when the JS discount system
 *    populates [data-discount], reformat it to match the v2 "Bulk Savings"
 *    layout: heading + pill badge.
 */
(function () {

  // ── Variant stepper ──────────────────────────────────────────────

  // Prevent theme's built-in qty component from initialising on variant wrappers
  var observer = new MutationObserver(function () {
    document.querySelectorAll('.js-qty__wrapper--variant .js-qty__num').forEach(function (input) {
      input.removeAttribute('name');
    });
    // Also reformat any newly-populated discount badges
    reformatDiscountBadges();
  });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('.js-qty__adjust');
    if (!btn) return;

    var wrapper = btn.closest('.js-qty__wrapper--variant');
    if (!wrapper) return;

    evt.preventDefault();
    evt.stopPropagation();

    var tiers = JSON.parse(wrapper.getAttribute('data-qty-tiers'));
    var currentVariantId = parseInt(wrapper.getAttribute('data-current-variant'), 10);
    var input = wrapper.querySelector('.js-qty__num');

    tiers.sort(function (a, b) { return a.qty - b.qty; });

    var currentIndex = 0;
    for (var i = 0; i < tiers.length; i++) {
      if (tiers[i].id === currentVariantId) {
        currentIndex = i;
        break;
      }
    }

    var isMinus = btn.classList.contains('js-qty__adjust--minus');
    var nextIndex = isMinus ? currentIndex - 1 : currentIndex + 1;

    if (nextIndex < 0 || nextIndex >= tiers.length) return;

    var nextTier = tiers[nextIndex];
    if (nextTier.id === currentVariantId) return;

    input.value = nextTier.qty;
    wrapper.classList.add('is-loading');

    var properties = {};
    try {
      var propsRaw = JSON.parse(wrapper.getAttribute('data-properties'));
      if (Array.isArray(propsRaw)) {
        propsRaw.forEach(function (p) {
          if (p[0] && p[1] !== '') properties[p[0]] = p[1];
        });
      } else if (propsRaw && typeof propsRaw === 'object') {
        properties = propsRaw;
      }
    } catch (e) {}

    var lineKey = wrapper.getAttribute('data-line-key');

    fetch(theme.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      var addData = { id: nextTier.id, quantity: 1 };
      if (Object.keys(properties).length > 0) addData.properties = properties;
      return fetch(theme.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [addData] })
      });
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      document.dispatchEvent(new CustomEvent('cart:build'));
    })
    .catch(function (err) {
      console.error('Variant swap failed:', err);
      input.value = tiers[currentIndex].qty;
      wrapper.classList.remove('is-loading');
    });

  }, true);


  // ── Reformat old-template discount badges ────────────────────────
  //
  // The theme's JS discount system populates small[data-discount] with
  // text like "5% Off (-$2.50)". We watch for that and restructure it
  // into the same layout the v2 template uses:
  //   BULK SAVINGS
  //   $x.xx/ea   Save X%
  //
  function reformatDiscountBadges() {
    document.querySelectorAll('small.cart__discount[data-discount]').forEach(function (el) {
      if (el.classList.contains('md-reformatted')) return;
      var text = el.textContent.trim();
      if (!text) return;

      el.classList.add('md-reformatted');

      // Build replacement markup
      var container = document.createElement('div');
      container.className = 'cart__bulk-savings-wrap';
      container.style.textAlign = 'right';
      container.style.marginTop = '6px';

      var heading = document.createElement('div');
      heading.className = 'cart__bulk-heading';
      heading.textContent = 'Bulk Savings';

      var badge = document.createElement('div');
      badge.className = 'cart__bulk-savings';
      badge.innerHTML = '<span class="cart__bulk-save-badge">' + text + '</span>';

      container.appendChild(heading);
      container.appendChild(badge);

      el.parentNode.insertBefore(container, el.nextSibling);
    });
  }

  // Run on load in case discounts are already rendered
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reformatDiscountBadges);
  } else {
    reformatDiscountBadges();
  }
  // Also run after cart rebuilds
  document.addEventListener('cart:build', function () {
    setTimeout(reformatDiscountBadges, 500);
  });

})();
